import { useApp } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SYLLAPLUS_LOGO_B64 } from "../constants";

export default function LoginPage() {
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const {
    token, authView, setAuthView, email, setEmail, password, setPassword,
    authError, setAuthError, passwordStrength, setPasswordStrength,
    getPasswordStrength, handleLogin, handleSignup, strengthColors, strengthWidths,
    firstName, setFirstName, lastName, setLastName, handleForgotPassword,
  } = useApp();

  useEffect(() => {
    if (token) navigate("/app/files", { replace: true });
  }, [token, navigate]);

  const submitForgotPassword = async () => {
    if (!forgotEmail.trim()) { setForgotMessage("Please enter your email address."); return; }
    setForgotLoading(true);
    setForgotMessage("");
    const result = await handleForgotPassword(forgotEmail);
    setForgotMessage(result.message);
    setForgotLoading(false);
  };

  return (
    <div style={{ maxWidth: "400px", margin: "80px auto", padding: "0 20px", fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          <img src={`data:image/png;base64,${SYLLAPLUS_LOGO_B64}`} alt="SyllaPlus" style={{ width: "32px", height: "32px" }} />
          <span style={{ fontSize: "22px", fontWeight: "500", color: "#1C2B3A" }}>SyllaPlus</span>
        </div>
        <p style={{ fontSize: "14px", color: "#6B7280", margin: 0 }}>Your course materials, instantly searchable</p>
      </div>
      <div style={{ background: "white", border: "0.5px solid #E5E7EB", borderRadius: "12px", padding: "24px" }}>
        <div style={{ display: "flex", marginBottom: "20px", borderBottom: "0.5px solid #E5E7EB" }}>
          {["login", "signup"].map(v => (
            <button key={v} onClick={() => { setAuthView(v); setAuthError(""); setEmail(""); setPassword(""); setFirstName(""); setLastName(""); setPasswordStrength(""); }}
              style={{ flex: 1, padding: "10px", background: "none", border: "none", cursor: "pointer", fontSize: "14px", fontWeight: authView === v ? "500" : "400", color: authView === v ? "#1C2B3A" : "#6B7280", borderBottom: `2px solid ${authView === v ? "#1C2B3A" : "transparent"}`, marginBottom: "-0.5px" }}>
              {v === "login" ? "Log in" : "Sign up"}
            </button>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {authView === "signup" && (
            <>
              <input type="text" placeholder="First name *" value={firstName} onChange={e => setFirstName(e.target.value)}
                onKeyDown={e => e.key === "Enter" && (authView === "login" ? handleLogin() : handleSignup())}
                style={{ padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB" }} />
              <input type="text" placeholder="Last name *" value={lastName} onChange={e => setLastName(e.target.value)}
                onKeyDown={e => e.key === "Enter" && (authView === "login" ? handleLogin() : handleSignup())}
                style={{ padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB" }} />
            </>
          )}
          <input type="email" placeholder={authView === "signup" ? "Email address *" : "Email address"} value={email} onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && (authView === "login" ? handleLogin() : handleSignup())}
            style={{ padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB" }} />
          <div>
            <input type="password" placeholder={authView === "signup" ? "Password *" : "Password"} value={password}
              onChange={e => { setPassword(e.target.value); if (authView === "signup") setPasswordStrength(getPasswordStrength(e.target.value)); }}
              onKeyDown={e => e.key === "Enter" && (authView === "login" ? handleLogin() : handleSignup())}
              style={{ width: "100%", padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB", boxSizing: "border-box" }} />
            {authView === "signup" && passwordStrength && (
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "8px" }}>
                <div style={{ flex: 1, height: "4px", background: "#E5E7EB", borderRadius: "2px", overflow: "hidden" }}>
                  <div style={{ height: "100%", width: strengthWidths[passwordStrength], background: strengthColors[passwordStrength], borderRadius: "2px", transition: "all 0.3s" }} />
                </div>
                <span style={{ fontSize: "12px", color: strengthColors[passwordStrength], minWidth: "36px" }}>{passwordStrength.charAt(0).toUpperCase() + passwordStrength.slice(1)}</span>
              </div>
            )}
          </div>
          {authView === "login" && !showForgotPassword && (
            <span onClick={() => { setShowForgotPassword(true); setForgotEmail(email); setForgotMessage(""); }}
              style={{ fontSize: "12px", color: "#6B7280", cursor: "pointer", alignSelf: "flex-end", marginTop: "-4px" }}>
              Forgot password?
            </span>
          )}
          {authError && <p style={{ fontSize: "13px", color: authError.includes("created") ? "#22c55e" : "#ef4444", margin: 0 }}>{authError}</p>}
          <button onClick={authView === "login" ? handleLogin : handleSignup}
            style={{ padding: "11px", background: "#1C2B3A", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", cursor: "pointer", fontWeight: "500", marginTop: "4px" }}>
            {authView === "login" ? "Log in" : "Create account"}
          </button>
        </div>

        {showForgotPassword && (
          <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "0.5px solid #E5E7EB" }}>
            <p style={{ fontSize: "13px", color: "#4B5563", marginBottom: "10px" }}>Enter your email and we'll send you a link to reset your password.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <input type="email" placeholder="Email address" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)}
                onKeyDown={e => e.key === "Enter" && submitForgotPassword()}
                style={{ padding: "10px 14px", borderRadius: "8px", border: "0.5px solid #E5E7EB", fontSize: "14px", outline: "none", background: "#F9FAFB" }} />
              {forgotMessage && <p style={{ fontSize: "13px", color: forgotMessage.includes("sent") ? "#22c55e" : "#ef4444", margin: 0 }}>{forgotMessage}</p>}
              <div style={{ display: "flex", gap: "8px" }}>
                <button onClick={() => { setShowForgotPassword(false); setForgotMessage(""); }}
                  style={{ flex: 1, padding: "9px", background: "transparent", border: "0.5px solid #E5E7EB", borderRadius: "8px", fontSize: "13px", cursor: "pointer", color: "#6B7280" }}>
                  Cancel
                </button>
                <button onClick={submitForgotPassword} disabled={forgotLoading}
                  style={{ flex: 1, padding: "9px", background: forgotLoading ? "#9CA3AF" : "#1C2B3A", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: forgotLoading ? "default" : "pointer", fontWeight: "500" }}>
                  {forgotLoading ? "Sending..." : "Send Link"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}